/* eslint-disable complexity */
import {
  AbwesenheitsStation,
  ArbeitsbereichStation,
} from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

export function hasUeberschneidungen(
  stationen: (ArbeitsbereichStation | AbwesenheitsStation)[],
  currentStation: ArbeitsbereichStation | AbwesenheitsStation | undefined,
  inputVon: Date | undefined,
  inputBis: Date | undefined,
): boolean {
  const ueberschneidendeStationen = stationen
    .filter((station) => station.id !== currentStation?.id)
    .filter(({ von, bis }) => {
      const ueberschneidetVon =
        inputVon !== undefined &&
        dayjs(inputVon).isBetween(von, bis, 'day', '[]');
      const ueberschneidetBis =
        inputBis !== undefined &&
        dayjs(inputBis).isBetween(von, bis, 'day', '[]');
      const ueberschneidetStation =
        inputVon !== undefined &&
        inputBis !== undefined &&
        dayjs(inputVon).isBefore(von) &&
        dayjs(inputBis).isAfter(bis);

      return ueberschneidetVon || ueberschneidetBis || ueberschneidetStation;
    });

  return ueberschneidendeStationen.length > 0;
}
